import { apiSlice } from './apiSlice';
export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendContact: builder.mutation({ query: (body) => ({ url: '/api/contact', method: 'POST', body }) }),
  }),
});
export const { useSendContactMutation } = contactApiSlice;
